import TileGrid from "./TileGrid.vue";
import { pluginify } from "./../../util";
export default pluginify(TileGrid);
export { TileGrid };
